import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { TimeframeEnum } from '@api/models/timeframe-enum';
import { EnumService, EnumObject } from '@core/services/enum.service';

@Component({
  selector: 'flow-timeframe-select',
  templateUrl: './timeframe-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TimeframeSelectComponent implements ControlValueAccessor {
  @Input() label = 'global.timeframe';
  @Input() isDisabled = false;
  @Input() required = false;
  @Output() selectionChange = new EventEmitter<TimeframeEnum>();

  protected control = inject(NgControl, { optional: true, self: true });
  private cdr = inject(ChangeDetectorRef);
  private enumService = inject(EnumService);

  readonly timeframeOptions: EnumObject<TimeframeEnum>[] = this.enumService.timeframeTypes;
  value: TimeframeEnum;

  constructor() {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  onChange = (value: TimeframeEnum) => { };
  onTouched = () => { };

  trackByOptionId = (_: number, option: EnumObject<TimeframeEnum>): number => option.id;

  writeValue(value: TimeframeEnum): void {
    this.value = value;
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.cdr.markForCheck();
  }

  onSelectChange(value: TimeframeEnum): void {
    this.value = value;
    this.onChange(value);
    this.onTouched();
    this.selectionChange.emit(value);
  }
}
